import * as types from "./dropdownMgmtActionType";

// RAD Type Actions - start
export const fetchRadTypesRequest = () => ({
  type: types.FETCH_RADTYPES_REQUEST,
});
export const fetchRadTypesSuccess = (data) => ({
  type: types.FETCH_RADTYPES_SUCCESS,
  payload: data,
});
export const fetchRadTypesFailure = (data) => ({
  type: types.FETCH_RADTYPES_FAILURE,
  payload: data,
});

export const deleteRadTypeRequest = (radTypeId, modifiedBy) => ({
  type: types.DELETE_RADTYPE_REQUEST,
  payload: { radTypeId, modifiedBy },
});
export const deleteRadTypeSuccess = (radTypeId) => ({
  type: types.DELETE_RADTYPE_SUCCESS,
  payload: radTypeId,
});
export const deleteRadTypeFailure = (error) => ({
  type: types.DELETE_RADTYPE_FAILURE,
  payload: error,
});

export const saveRadTypeRequest = (radTypeData) => ({
  type: types.SAVE_RADTYPE_REQUEST,
  payload: radTypeData,
});
export const saveRadTypeSuccess = (radType) => ({
  type: types.SAVE_RADTYPE_SUCCESS,
  payload: radType,
});
export const saveRadTypeFailure = (error) => ({
  type: types.SAVE_RADTYPE_FAILURE,
  payload: error,
});

export const fetchRadTypeByIdRequest = (radTypeId) => ({
  type: types.FETCH_RADTYPE_BY_ID_REQUEST,
  payload: { radTypeId },
});
export const fetchRadTypeByIdSuccess = (radType) => ({
  type: types.FETCH_RADTYPE_BY_ID_SUCCESS,
  payload: radType,
});
export const fetchRadTypeByIdFailure = (error) => ({
  type: types.FETCH_RADTYPE_BY_ID_FAILURE,
  payload: error,
});

export const updateRadTypeRequest = (radTypeData) => ({
  type: types.UPDATE_RADTYPE_REQUEST,
  payload: radTypeData,
});
export const updateRadTypeSuccess = (radType) => ({
  type: types.UPDATE_RADTYPE_SUCCESS,
  payload: radType,
});
export const updateRadTypeFailure = (error) => ({
  type: types.UPDATE_RADTYPE_FAILURE,
  payload: error,
});

export const activateDeactivateRadTypeRequest = (
  radTypeId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_RADTYPE_REQUEST,
  payload: { radTypeId, status, userId },
});
export const activateDeactivateRadTypeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_RADTYPE_SUCCESS,
  payload: result,
});
export const activateDeactivateRadTypeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RADTYPE_FAILURE,
  payload: error,
});
// RAD Type Actions - end

// RAD Status Actions - start
export const fetchRadStatusRequest = () => ({
  type: types.FETCH_RADSTATUS_REQUEST,
});
export const fetchRadStatusSuccess = (data) => ({
  type: types.FETCH_RADSTATUS_SUCCESS,
  payload: data,
});
export const fetchRadStatusFailure = (data) => ({
  type: types.FETCH_RADSTATUS_FAILURE,
  payload: data,
});

export const deleteRadStatusRequest = (radStatusId, modifiedBy) => ({
  type: types.DELETE_RADSTATUS_REQUEST,
  payload: { radStatusId, modifiedBy },
});
export const deleteRadStatusSuccess = (radStatusId) => ({
  type: types.DELETE_RADSTATUS_SUCCESS,
  payload: radStatusId,
});
export const deleteRadStatusFailure = (error) => ({
  type: types.DELETE_RADSTATUS_FAILURE,
  payload: error,
});

export const saveRadStatusRequest = (radStatusData) => ({
  type: types.SAVE_RADSTATUS_REQUEST,
  payload: radStatusData,
});
export const saveRadStatusSuccess = (radStatus) => ({
  type: types.SAVE_RADSTATUS_SUCCESS,
  payload: radStatus,
});
export const saveRadStatusFailure = (error) => ({
  type: types.SAVE_RADSTATUS_FAILURE,
  payload: error,
});

export const fetchRadStatusByIdRequest = (radStatusId) => ({
  type: types.FETCH_RADSTATUS_BY_ID_REQUEST,
  payload: radStatusId,
});
export const fetchRadStatusByIdSuccess = (radStatus) => ({
  type: types.FETCH_RADSTATUS_BY_ID_SUCCESS,
  payload: radStatus,
});
export const fetchRadStatusByIdFailure = (error) => ({
  type: types.FETCH_RADSTATUS_BY_ID_FAILURE,
  payload: error,
});

export const updateRadStatusRequest = (radStatusData) => ({
  type: types.UPDATE_RADSTATUS_REQUEST,
  payload: radStatusData,
});
export const updateRadStatusSuccess = (radStatus) => ({
  type: types.UPDATE_RADSTATUS_SUCCESS,
  payload: radStatus,
});
export const updateRadStatusFailure = (error) => ({
  type: types.UPDATE_RADSTATUS_FAILURE,
  payload: error,
});

export const activateDeactivateRadStatusRequest = (
  radStatusId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_RADSTATUS_REQUEST,
  payload: { radStatusId, status, userId },
});
export const activateDeactivateRadStatusSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_RADSTATUS_SUCCESS,
  payload: result,
});
export const activateDeactivateRadStatusFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RADSTATUS_FAILURE,
  payload: error,
});
// RAD Status Actions - end

// Subspeciality Actions - start
export const fetchSubspecialitiesRequest = () => ({
  type: types.FETCH_SUBSPECIALITIES_REQUEST,
});
export const fetchSubspecialitiesSuccess = (subspecialities) => ({
  type: types.FETCH_SUBSPECIALITIES_SUCCESS,
  payload: subspecialities,
});
export const fetchSubspecialitiesFailure = (error) => ({
  type: types.FETCH_SUBSPECIALITIES_FAILURE,
  payload: error,
});

export const fetchSubspecialityByIdRequest = (SubSpecialityID) => ({
  type: types.FETCH_SUBSPECIALITY_BY_ID_REQUEST,
  payload: SubSpecialityID,
});
export const fetchSubspecialityByIdSuccess = (subspeciality) => ({
  type: types.FETCH_SUBSPECIALITY_BY_ID_SUCCESS,
  payload: subspeciality,
});
export const fetchSubspecialityByIdFailure = (error) => ({
  type: types.FETCH_SUBSPECIALITY_BY_ID_FAILURE,
  payload: error,
});

export const saveSubspecialityRequest = (subspecialityData) => ({
  type: types.SAVE_SUBSPECIALITY_REQUEST,
  payload: subspecialityData,
});
export const saveSubspecialitySuccess = (message) => ({
  type: types.SAVE_SUBSPECIALITY_SUCCESS,
  payload: message,
});
export const saveSubspecialityFailure = (error) => ({
  type: types.SAVE_SUBSPECIALITY_FAILURE,
  payload: error,
});

export const deleteSubspecialityRequest = (subspecialityId, modifiedBy) => ({
  type: types.DELETE_SUBSPECIALITY_REQUEST,
  payload: { subspecialityId, modifiedBy },
});
export const deleteSubspecialitySuccess = (message) => ({
  type: types.DELETE_SUBSPECIALITY_SUCCESS,
  payload: message,
});
export const deleteSubspecialityFailure = (error) => ({
  type: types.DELETE_SUBSPECIALITY_FAILURE,
  payload: error,
});

export const activateDeactivateSubspecialityRequest = (
  subspecialityId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_REQUEST,
  payload: { subspecialityId, isActive, modifiedBy },
});
export const activateDeactivateSubspecialitySuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_SUCCESS,
  payload: message,
});
export const activateDeactivateSubspecialityFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_FAILURE,
  payload: error,
});
// Subspeciality Actions - end

// Week Rotation Actions - start
export const fetchWeekRotationsRequest = () => ({
  type: types.FETCH_WEEK_ROTATIONS_REQUEST,
});
export const fetchWeekRotationsSuccess = (weekRotations) => ({
  type: types.FETCH_WEEK_ROTATIONS_SUCCESS,
  payload: weekRotations,
});
export const fetchWeekRotationsFailure = (error) => ({
  type: types.FETCH_WEEK_ROTATIONS_FAILURE,
  payload: error,
});

export const saveWeekRotationRequest = (weekRotationData) => ({
  type: types.SAVE_WEEK_ROTATION_REQUEST,
  payload: weekRotationData,
});
export const saveWeekRotationSuccess = (data) => ({
  type: types.SAVE_WEEK_ROTATION_SUCCESS,
  payload: data,
});
export const saveWeekRotationFailure = (error) => ({
  type: types.SAVE_WEEK_ROTATION_FAILURE,
  payload: error,
});

export const deleteWeekRotationRequest = (weekRotationId, modifiedBy) => ({
  type: types.DELETE_WEEK_ROTATION_REQUEST,
  payload: { weekRotationId, modifiedBy },
});
export const deleteWeekRotationSuccess = (message) => ({
  type: types.DELETE_WEEK_ROTATION_SUCCESS,
  payload: message,
});
export const deleteWeekRotationFailure = (error) => ({
  type: types.DELETE_WEEK_ROTATION_FAILURE,
  payload: error,
});

export const activateDeactivateWeekRotationRequest = (Id, Status, UserId) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_REQUEST,
  payload: { Id, Status, UserId },
});
export const activateDeactivateWeekRotationSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_SUCCESS,
  payload: message,
});
export const activateDeactivateWeekRotationFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_FAILURE,
  payload: error,
});

export const fetchWeekRotationByIdRequest = (weekRotationId) => ({
  type: types.FETCH_WEEK_ROTATION_BY_ID_REQUEST,
  payload: { weekRotationId },
});
export const fetchWeekRotationByIdSuccess = (weekRotationData) => ({
  type: types.FETCH_WEEK_ROTATION_BY_ID_SUCCESS,
  payload: weekRotationData,
});
export const fetchWeekRotationByIdFailure = (error) => ({
  type: types.FETCH_WEEK_ROTATION_BY_ID_FAILURE,
  payload: error,
});
// Week Rotation Actions - end

// Week Rotation Template Actions - start
export const fetchWeekRotationTemplatesRequest = () => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATES_REQUEST,
});
export const fetchWeekRotationTemplatesSuccess = (weekRotationTemplates) => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATES_SUCCESS,
  payload: weekRotationTemplates,
});
export const fetchWeekRotationTemplatesFailure = (error) => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATES_FAILURE,
  payload: error,
});

export const fetchWeekRotationTemplateByIdRequest = (templateId) => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST,
  payload: { templateId },
});
export const fetchWeekRotationTemplateByIdSuccess = (templateData) => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS,
  payload: templateData,
});
export const fetchWeekRotationTemplateByIdFailure = (error) => ({
  type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE,
  payload: error,
});

export const deleteWeekRotationTemplateRequest = (templateId, modifiedBy) => ({
  type: types.DELETE_WEEK_ROTATION_TEMPLATE_REQUEST,
  payload: { templateId, modifiedBy },
});
export const deleteWeekRotationTemplateSuccess = (message) => ({
  type: types.DELETE_WEEK_ROTATION_TEMPLATE_SUCCESS,
  payload: message,
});
export const deleteWeekRotationTemplateFailure = (error) => ({
  type: types.DELETE_WEEK_ROTATION_TEMPLATE_FAILURE,
  payload: error,
});

export const activateDeactivateWeekRotationTemplateRequest = (
  templateId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_REQUEST,
  payload: { templateId, isActive, modifiedBy },
});
export const activateDeactivateWeekRotationTemplateSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_SUCCESS,
  payload: message,
});
export const activateDeactivateWeekRotationTemplateFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_FAILURE,
  payload: error,
});

export const saveWeekRotationTemplateRequest = (payload) => ({
  type: types.SAVE_WEEK_ROTATION_TEMPLATE_REQUEST,
  payload,
});
export const saveWeekRotationTemplateSuccess = (message) => ({
  type: types.SAVE_WEEK_ROTATION_TEMPLATE_SUCCESS,
  payload: message,
});
export const saveWeekRotationTemplateFailure = (error) => ({
  type: types.SAVE_WEEK_ROTATION_TEMPLATE_FAILURE,
  payload: error,
});
// Week Rotation Template Actions - end

// Partnership Rate Actions - start
export const fetchPartnershipRatesRequest = () => ({
  type: types.FETCH_PARTNERSHIP_RATES_REQUEST,
});
export const fetchPartnershipRatesSuccess = (partnershipRates) => ({
  type: types.FETCH_PARTNERSHIP_RATES_SUCCESS,
  payload: partnershipRates,
});
export const fetchPartnershipRatesFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_RATES_FAILURE,
  payload: error,
});

export const fetchPartnershipRateByIdRequest = (partnershipRateId) => ({
  type: types.FETCH_PARTNERSHIP_RATE_BY_ID_REQUEST,
  payload: partnershipRateId,
});
export const fetchPartnershipRateByIdSuccess = (partnershipRate) => ({
  type: types.FETCH_PARTNERSHIP_RATE_BY_ID_SUCCESS,
  payload: partnershipRate,
});
export const fetchPartnershipRateByIdFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_RATE_BY_ID_FAILURE,
  payload: error,
});

export const savePartnershipRateRequest = (partnershipRateData) => ({
  type: types.SAVE_PARTNERSHIP_RATE_REQUEST,
  payload: partnershipRateData,
});
export const savePartnershipRateSuccess = (message) => ({
  type: types.SAVE_PARTNERSHIP_RATE_SUCCESS,
  payload: message,
});
export const savePartnershipRateFailure = (error) => ({
  type: types.SAVE_PARTNERSHIP_RATE_FAILURE,
  payload: error,
});

export const deletePartnershipRateRequest = (
  partnershipRateId,
  modifiedBy,
) => ({
  type: types.DELETE_PARTNERSHIP_RATE_REQUEST,
  payload: { partnershipRateId, modifiedBy },
});
export const deletePartnershipRateSuccess = (message) => ({
  type: types.DELETE_PARTNERSHIP_RATE_SUCCESS,
  payload: message,
});
export const deletePartnershipRateFailure = (error) => ({
  type: types.DELETE_PARTNERSHIP_RATE_FAILURE,
  payload: error,
});

export const activateDeactivatePartnershipRateRequest = (
  partnershipRateId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_REQUEST,
  payload: { partnershipRateId, isActive, modifiedBy },
});
export const activateDeactivatePartnershipRateSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_SUCCESS,
  payload: message,
});
export const activateDeactivatePartnershipRateFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_FAILURE,
  payload: error,
});
// Partnership Rate Actions - end

// Partnership Status Actions - start
export const fetchPartnershipStatusesRequest = () => ({
  type: types.FETCH_PARTNERSHIP_STATUSES_REQUEST,
});
export const fetchPartnershipStatusesSuccess = (partnershipStatuses) => ({
  type: types.FETCH_PARTNERSHIP_STATUSES_SUCCESS,
  payload: partnershipStatuses,
});
export const fetchPartnershipStatusesFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_STATUSES_FAILURE,
  payload: error,
});

export const fetchPartnershipStatusByIdRequest = (partnershipStatusId) => ({
  type: types.FETCH_PARTNERSHIP_STATUS_BY_ID_REQUEST,
  payload: partnershipStatusId,
});
export const fetchPartnershipStatusByIdSuccess = (partnershipStatus) => ({
  type: types.FETCH_PARTNERSHIP_STATUS_BY_ID_SUCCESS,
  payload: partnershipStatus,
});
export const fetchPartnershipStatusByIdFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_STATUS_BY_ID_FAILURE,
  payload: error,
});

export const savePartnershipStatusRequest = (partnershipStatusData) => ({
  type: types.SAVE_PARTNERSHIP_STATUS_REQUEST,
  payload: partnershipStatusData,
});
export const savePartnershipStatusSuccess = (message) => ({
  type: types.SAVE_PARTNERSHIP_STATUS_SUCCESS,
  payload: message,
});
export const savePartnershipStatusFailure = (error) => ({
  type: types.SAVE_PARTNERSHIP_STATUS_FAILURE,
  payload: error,
});

export const deletePartnershipStatusRequest = (
  partnershipStatusId,
  modifiedBy,
) => ({
  type: types.DELETE_PARTNERSHIP_STATUS_REQUEST,
  payload: { partnershipStatusId, modifiedBy },
});
export const deletePartnershipStatusSuccess = (message) => ({
  type: types.DELETE_PARTNERSHIP_STATUS_SUCCESS,
  payload: message,
});
export const deletePartnershipStatusFailure = (error) => ({
  type: types.DELETE_PARTNERSHIP_STATUS_FAILURE,
  payload: error,
});

export const activateDeactivatePartnershipStatusRequest = (
  partnershipStatusId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_REQUEST,
  payload: { partnershipStatusId, isActive, modifiedBy },
});
export const activateDeactivatePartnershipStatusSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_SUCCESS,
  payload: message,
});
export const activateDeactivatePartnershipStatusFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_FAILURE,
  payload: error,
});
// Partnership Status Actions - end

// Partnership Time Actions - start
export const fetchPartnershipTimesRequest = () => ({
  type: types.FETCH_PARTNERSHIP_TIMES_REQUEST,
});
export const fetchPartnershipTimesSuccess = (partnershipTimes) => ({
  type: types.FETCH_PARTNERSHIP_TIMES_SUCCESS,
  payload: partnershipTimes,
});
export const fetchPartnershipTimesFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_TIMES_FAILURE,
  payload: error,
});

export const fetchPartnershipTimeByIdRequest = (RadPartnershipTimeID) => ({
  type: types.FETCH_PARTNERSHIP_TIME_BY_ID_REQUEST,
  payload: RadPartnershipTimeID,
});
export const fetchPartnershipTimeByIdSuccess = (partnershipTime) => ({
  type: types.FETCH_PARTNERSHIP_TIME_BY_ID_SUCCESS,
  payload: partnershipTime,
});
export const fetchPartnershipTimeByIdFailure = (error) => ({
  type: types.FETCH_PARTNERSHIP_TIME_BY_ID_FAILURE,
  payload: error,
});

export const savePartnershipTimeRequest = (partnershipTimeData) => ({
  type: types.SAVE_PARTNERSHIP_TIME_REQUEST,
  payload: partnershipTimeData,
});
export const savePartnershipTimeSuccess = (message) => ({
  type: types.SAVE_PARTNERSHIP_TIME_SUCCESS,
  payload: message,
});
export const savePartnershipTimeFailure = (error) => ({
  type: types.SAVE_PARTNERSHIP_TIME_FAILURE,
  payload: error,
});

export const deletePartnershipTimeRequest = (
  partnershipTimeId,
  modifiedBy,
) => ({
  type: types.DELETE_PARTNERSHIP_TIME_REQUEST,
  payload: { partnershipTimeId, modifiedBy },
});
export const deletePartnershipTimeSuccess = (message) => ({
  type: types.DELETE_PARTNERSHIP_TIME_SUCCESS,
  payload: message,
});
export const deletePartnershipTimeFailure = (error) => ({
  type: types.DELETE_PARTNERSHIP_TIME_FAILURE,
  payload: error,
});

export const activateDeactivatePartnershipTimeRequest = (
  partnershipTimeId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_REQUEST,
  payload: { partnershipTimeId, isActive, modifiedBy },
});
export const activateDeactivatePartnershipTimeSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_SUCCESS,
  payload: message,
});
export const activateDeactivatePartnershipTimeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_FAILURE,
  payload: error,
});
// Partnership Time Actions - end

//radDegree Actions - START
export const fetchRadDegreeRequest = () => ({
  type: types.FETCH_RAD_DEGREE_REQUEST,
});
export const fetchRadDegreeSuccess = (data) => ({
  type: types.FETCH_RAD_DEGREE_SUCCESS,
  payload: data,
});
export const fetchRadDegreeFailure = (error) => ({
  type: types.FETCH_RAD_DEGREE_FAILURE,
  payload: error,
});

export const deleteRadDegreeRequest = (RadDegreeID, modifiedBy) => ({
  type: types.DELETE_RAD_DEGREE_REQUEST,
  payload: { RadDegreeID, modifiedBy },
});
export const deleteRadDegreeSuccess = (RadDegreeID) => ({
  type: types.DELETE_RAD_DEGREE_SUCCESS,
  payload: RadDegreeID,
});
export const deleteRadDegreeFailure = (error) => ({
  type: types.DELETE_RAD_DEGREE_FAILURE,
  payload: error,
});

export const saveRadDegreeRequest = (radDegreeData) => ({
  type: types.SAVE_RAD_DEGREE_REQUEST,
  payload: radDegreeData,
});
export const saveRadDegreeSuccess = (radDegree) => ({
  type: types.SAVE_RAD_DEGREE_SUCCESS,
  payload: radDegree,
});
export const saveRadDegreeFailure = (error) => ({
  type: types.SAVE_RAD_DEGREE_FAILURE,
  payload: error,
});

export const fetchRadDegreeByIdRequest = (RadDegreeID) => ({
  type: types.FETCH_RAD_DEGREE_BY_ID_REQUEST,
  payload: { RadDegreeID },
});
export const fetchRadDegreeByIdSuccess = (radDegree) => ({
  type: types.FETCH_RAD_DEGREE_BY_ID_SUCCESS,
  payload: radDegree,
});
export const fetchRadDegreeByIdFailure = (error) => ({
  type: types.FETCH_RAD_DEGREE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateRadDegreeRequest = (
  RadDegreeID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_DEGREE_REQUEST,
  payload: { RadDegreeID, status, userId },
});
export const activateDeactivateRadDegreeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_DEGREE_SUCCESS,
  payload: result,
});
export const activateDeactivateRadDegreeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_DEGREE_FAILURE,
  payload: error,
});
//radDegree Actions - END

//committees Actions - START
export const fetchCommitteesRequest = () => ({
  type: types.FETCH_COMMITTEES_REQUEST,
});
export const fetchCommitteesSuccess = (data) => ({
  type: types.FETCH_COMMITTEES_SUCCESS,
  payload: data,
});
export const fetchCommitteesFailure = (error) => ({
  type: types.FETCH_COMMITTEES_FAILURE,
  payload: error,
});

export const deleteCommitteesRequest = (RadCommitteeID, modifiedBy) => ({
  type: types.DELETE_COMMITTEES_REQUEST,
  payload: { RadCommitteeID, modifiedBy },
});
export const deleteCommitteesSuccess = (RadCommitteeID) => ({
  type: types.DELETE_COMMITTEES_SUCCESS,
  payload: RadCommitteeID,
});
export const deleteCommitteesFailure = (error) => ({
  type: types.DELETE_COMMITTEES_FAILURE,
  payload: error,
});

export const saveCommitteesRequest = (RadCommitteeData) => ({
  type: types.SAVE_COMMITTEES_REQUEST,
  payload: RadCommitteeData,
});
export const saveCommitteesSuccess = (RadCommittee) => ({
  type: types.SAVE_COMMITTEES_SUCCESS,
  payload: RadCommittee,
});
export const saveCommitteesFailure = (error) => ({
  type: types.SAVE_COMMITTEES_FAILURE,
  payload: error,
});

export const fetchCommitteesByIdRequest = (RadCommitteeID) => ({
  type: types.FETCH_COMMITTEES_BY_ID_REQUEST,
  payload: { RadCommitteeID },
});
export const fetchCommitteesByIdSuccess = (RadCommittee) => ({
  type: types.FETCH_COMMITTEES_BY_ID_SUCCESS,
  payload: RadCommittee,
});
export const fetchCommitteesByIdFailure = (error) => ({
  type: types.FETCH_COMMITTEES_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateCommitteesRequest = (
  RadCommitteeID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_COMMITTEES_REQUEST,
  payload: { RadCommitteeID, status, userId },
});
export const activateDeactivateCommitteesSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_COMMITTEES_SUCCESS,
  payload: result,
});
export const activateDeactivateCommitteesFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_COMMITTEES_FAILURE,
  payload: error,
});
//Committees Actions - END

//Future Section Change Actions - START
export const fetchFutureSectionChangeRequest = () => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_REQUEST,
});
export const fetchFutureSectionChangeSuccess = (data) => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_SUCCESS,
  payload: data,
});
export const fetchFutureSectionChangeFailure = (error) => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_FAILURE,
  payload: error,
});

export const deleteFutureSectionChangeRequest = (
  RadScheduleFutureSectionID,
  modifiedBy,
) => ({
  type: types.DELETE_FUTURE_SECTION_CHANGE_REQUEST,
  payload: { RadScheduleFutureSectionID, modifiedBy },
});
export const deleteFutureSectionChangeSuccess = (
  RadScheduleFutureSectionID,
) => ({
  type: types.DELETE_FUTURE_SECTION_CHANGE_SUCCESS,
  payload: RadScheduleFutureSectionID,
});
export const deleteFutureSectionChangeFailure = (error) => ({
  type: types.DELETE_FUTURE_SECTION_CHANGE_FAILURE,
  payload: error,
});

export const saveFutureSectionChangeRequest = (RadFutureSectionChangeData) => ({
  type: types.SAVE_FUTURE_SECTION_CHANGE_REQUEST,
  payload: RadFutureSectionChangeData,
});
export const saveFutureSectionChangeSuccess = (RadFutureSectionChange) => ({
  type: types.SAVE_FUTURE_SECTION_CHANGE_SUCCESS,
  payload: RadFutureSectionChange,
});
export const saveFutureSectionChangeFailure = (error) => ({
  type: types.SAVE_FUTURE_SECTION_CHANGE_FAILURE,
  payload: error,
});

export const fetchFutureSectionChangeByIdRequest = (
  RadScheduleFutureSectionID,
) => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_REQUEST,
  payload: { RadScheduleFutureSectionID },
});
export const fetchFutureSectionChangeByIdSuccess = (
  RadFutureSectionChange,
) => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_SUCCESS,
  payload: RadFutureSectionChange,
});
export const fetchFutureSectionChangeByIdFailure = (error) => ({
  type: types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateFutureSectionChangeRequest = (
  RadScheduleFutureSectionID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_REQUEST,
  payload: { RadScheduleFutureSectionID, status, userId },
});
export const activateDeactivateFutureSectionChangeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_SUCCESS,
  payload: result,
});
export const activateDeactivateFutureSectionChangeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_FAILURE,
  payload: error,
});
//Future Section Change Actions - END

// ScheduleType Actions - start
export const fetchScheduleTypeRequest = () => ({
  type: types.FETCH_SCHEDULETYPE_REQUEST,
});
export const fetchScheduleTypeSuccess = (data) => ({
  type: types.FETCH_SCHEDULETYPE_SUCCESS,
  payload: data,
});
export const fetchScheduleTypeFailure = (data) => ({
  type: types.FETCH_SCHEDULETYPE_FAILURE,
  payload: data,
});

export const deleteScheduleTypeRequest = (scheduleTypeId, modifiedBy) => ({
  type: types.DELETE_SCHEDULETYPE_REQUEST,
  payload: { scheduleTypeId, modifiedBy },
});
export const deleteScheduleTypeSuccess = (scheduleTypeId) => ({
  type: types.DELETE_SCHEDULETYPE_SUCCESS,
  payload: scheduleTypeId,
});
export const deleteScheduleTypeFailure = (error) => ({
  type: types.DELETE_SCHEDULETYPE_FAILURE,
  payload: error,
});

export const saveScheduleTypeRequest = (scheduleTypeData) => ({
  type: types.SAVE_SCHEDULETYPE_REQUEST,
  payload: scheduleTypeData,
});
export const saveScheduleTypeSuccess = (scheduleType) => ({
  type: types.SAVE_SCHEDULETYPE_SUCCESS,
  payload: scheduleType,
});
export const saveScheduleTypeFailure = (error) => ({
  type: types.SAVE_SCHEDULETYPE_FAILURE,
  payload: error,
});

export const fetchScheduleTypeByIdRequest = (scheduleTypeId) => ({
  type: types.FETCH_SCHEDULETYPE_BY_ID_REQUEST,
  payload: { scheduleTypeId },
});
export const fetchScheduleTypeByIdSuccess = (scheduleType) => ({
  type: types.FETCH_SCHEDULETYPE_BY_ID_SUCCESS,
  payload: scheduleType,
});
export const fetchScheduleTypeByIdFailure = (error) => ({
  type: types.FETCH_SCHEDULETYPE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateScheduleTypeRequest = (
  scheduleTypeId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_REQUEST,
  payload: { scheduleTypeId, status, userId },
});
export const activateDeactivateScheduleTypeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_SUCCESS,
  payload: result,
});
export const activateDeactivateScheduleTypeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_FAILURE,
  payload: error,
});
// Schedule Type Actions - end

// RadCommunicationType Actions - start
export const fetchRadCommunicationTypeRequest = () => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_REQUEST,
});
export const fetchRadCommunicationTypeSuccess = (data) => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_SUCCESS,
  payload: data,
});
export const fetchRadCommunicationTypeFailure = (data) => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_FAILURE,
  payload: data,
});

export const deleteRadCommunicationTypeRequest = (
  radCommunicationTypeId,
  modifiedBy,
) => ({
  type: types.DELETE_RAD_COMMUNICATION_TYPE_REQUEST,
  payload: { radCommunicationTypeId, modifiedBy },
});
export const deleteRadCommunicationTypeSuccess = (radCommunicationTypeId) => ({
  type: types.DELETE_RAD_COMMUNICATION_TYPE_SUCCESS,
  payload: radCommunicationTypeId,
});
export const deleteRadCommunicationTypeFailure = (error) => ({
  type: types.DELETE_RAD_COMMUNICATION_TYPE_FAILURE,
  payload: error,
});

export const saveRadCommunicationTypeRequest = (data) => ({
  type: types.SAVE_RAD_COMMUNICATION_TYPE_REQUEST,
  payload: data,
});
export const saveRadCommunicationTypeSuccess = (data) => ({
  type: types.SAVE_RAD_COMMUNICATION_TYPE_SUCCESS,
  payload: data,
});
export const saveRadCommunicationTypeFailure = (error) => ({
  type: types.SAVE_RAD_COMMUNICATION_TYPE_FAILURE,
  payload: error,
});

export const fetchRadCommunicationTypeByIdRequest = (Id) => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_REQUEST,
  payload: { RadCommunicationTypeID: Id },
});
export const fetchRadCommunicationTypeByIdSuccess = (data) => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_SUCCESS,
  payload: data,
});
export const fetchRadCommunicationTypeByIdFailure = (error) => ({
  type: types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateRadCommunicationTypeRequest = (
  radCommunicationTypeId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_REQUEST,
  payload: { radCommunicationTypeId, status, userId },
});
export const activateDeactivateRadCommunicationTypeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_SUCCESS,
  payload: result,
});
export const activateDeactivateRadCommunicationTypeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_FAILURE,
  payload: error,
});
// RadCommunicationType Actions - end

// RvuRate Actions - start
export const fetchRvuRateRequest = () => ({
  type: types.FETCH_RVURATE_REQUEST,
});
export const fetchRvuRateSuccess = (rvuRates) => ({
  type: types.FETCH_RVURATE_SUCCESS,
  payload: rvuRates,
});
export const fetchRvuRateFailure = (error) => ({
  type: types.FETCH_RVURATE_FAILURE,
  payload: error,
});

export const fetchRvuRateByIdRequest = (RadRUVRateID) => ({
  type: types.FETCH_RVURATE_BY_ID_REQUEST,
  payload: RadRUVRateID,
});
export const fetchRvuRateByIdSuccess = (rvuRate) => ({
  type: types.FETCH_RVURATE_BY_ID_SUCCESS,
  payload: rvuRate,
});
export const fetchRvuRateByIdFailure = (error) => ({
  type: types.FETCH_RVURATE_BY_ID_FAILURE,
  payload: error,
});

export const saveRvuRateRequest = (rvuRateData) => ({
  type: types.SAVE_RVURATE_REQUEST,
  payload: rvuRateData,
});
export const saveRvuRateSuccess = (message) => ({
  type: types.SAVE_RVURATE_SUCCESS,
  payload: message,
});
export const saveRvuRateFailure = (error) => ({
  type: types.SAVE_RVURATE_FAILURE,
  payload: error,
});

export const deleteRvuRateRequest = (rvuRateId, modifiedBy) => ({
  type: types.DELETE_RVURATE_REQUEST,
  payload: { rvuRateId, modifiedBy },
});
export const deleteRvuRateSuccess = (message) => ({
  type: types.DELETE_RVURATE_SUCCESS,
  payload: message,
});
export const deleteRvuRateFailure = (error) => ({
  type: types.DELETE_RVURATE_FAILURE,
  payload: error,
});

export const activateDeactivateRvuRateRequest = (
  rvuRateId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_RVURATE_REQUEST,
  payload: { rvuRateId, isActive, modifiedBy },
});
export const activateDeactivateRvuRateSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_RVURATE_SUCCESS,
  payload: message,
});
export const activateDeactivateRvuRateFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RVURATE_FAILURE,
  payload: error,
});
// RvuRate Actions - end

// TimeZone Actions - start
export const fetchTimeZonesRequest = () => ({
  type: types.FETCH_TIME_ZONES_REQUEST,
});
export const fetchTimeZonesSuccess = (timeZones) => ({
  type: types.FETCH_TIME_ZONES_SUCCESS,
  payload: timeZones,
});
export const fetchTimeZonesFailure = (error) => ({
  type: types.FETCH_TIME_ZONES_FAILURE,
  payload: error,
});

export const saveTimeZoneRequest = (timeZoneData) => ({
  type: types.SAVE_TIME_ZONE_REQUEST,
  payload: timeZoneData,
});
export const saveTimeZoneSuccess = (message) => ({
  type: types.SAVE_TIME_ZONE_SUCCESS,
  payload: message,
});
export const saveTimeZoneFailure = (error) => ({
  type: types.SAVE_TIME_ZONE_FAILURE,
  payload: error,
});

export const deleteTimeZoneRequest = (payload) => ({
  type: types.DELETE_TIME_ZONE_REQUEST,
  payload: payload,
});
export const deleteTimeZoneSuccess = (message) => ({
  type: types.DELETE_TIME_ZONE_SUCCESS,
  payload: message,
});
export const deleteTimeZoneFailure = (error) => ({
  type: types.DELETE_TIME_ZONE_FAILURE,
  payload: error,
});

export const activateDeactivateTimeZoneRequest = (
  timeZoneId,
  isActive,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_TIME_ZONE_REQUEST,
  payload: { timeZoneId, isActive, modifiedBy },
});
export const activateDeactivateTimeZoneSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_TIME_ZONE_SUCCESS,
  payload: message,
});
export const activateDeactivateTimeZoneFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_TIME_ZONE_FAILURE,
  payload: error,
});

export const fetchTimeZoneByIdRequest = (timeZoneId) => ({
  type: types.FETCH_TIME_ZONE_BY_ID_REQUEST,
  payload: timeZoneId,
});
export const fetchTimeZoneByIdSuccess = (timeZone) => ({
  type: types.FETCH_TIME_ZONE_BY_ID_SUCCESS,
  payload: timeZone,
});
export const fetchTimeZoneByIdFailure = (error) => ({
  type: types.FETCH_TIME_ZONE_BY_ID_FAILURE,
  payload: error,
});
// TimeZone Actions - end

//Requeststatus Actions - START
export const fetchRequeststatusRequest = () => ({
  type: types.FETCH_REQUESTSTATUS_REQUEST,
});
export const fetchRequeststatusSuccess = (data) => ({
  type: types.FETCH_REQUESTSTATUS_SUCCESS,
  payload: data,
});
export const fetchRequeststatusFailure = (error) => ({
  type: types.FETCH_REQUESTSTATUS_FAILURE,
  payload: error,
});

export const saveRequeststatusRequest = (requeststatusData) => ({
  type: types.SAVE_REQUESTSTATUS_REQUEST,
  payload: requeststatusData,
});
export const saveRequeststatusSuccess = (message) => ({
  type: types.SAVE_REQUESTSTATUS_SUCCESS,
  payload: message,
});
export const saveRequeststatusFailure = (error) => ({
  type: types.SAVE_REQUESTSTATUS_FAILURE,
  payload: error,
});

export const fetchRequeststatusByIdRequest = (RadScheduleRequestStatusID) => ({
  type: types.FETCH_REQUESTSTATUS_BY_ID_REQUEST,
  payload: RadScheduleRequestStatusID,
});
export const fetchRequeststatusByIdSuccess = (requeststatus) => ({
  type: types.FETCH_REQUESTSTATUS_BY_ID_SUCCESS,
  payload: requeststatus,
});
export const fetchRequeststatusByIdFailure = (error) => ({
  type: types.FETCH_REQUESTSTATUS_BY_ID_FAILURE,
  payload: error,
});

export const deleteRequeststatusRequest = (
  RadScheduleRequestStatusID,
  modifiedBy,
) => ({
  type: types.DELETE_REQUESTSTATUS_REQUEST,
  payload: { RadScheduleRequestStatusID, modifiedBy },
});
export const deleteRequeststatusSuccess = (RadScheduleRequestStatusID) => ({
  type: types.DELETE_REQUESTSTATUS_SUCCESS,
  payload: RadScheduleRequestStatusID,
});
export const deleteRequeststatusFailure = (error) => ({
  type: types.DELETE_REQUESTSTATUS_FAILURE,
  payload: error,
});

export const activateDeactivateRequeststatusRequest = (
  RadScheduleRequestStatusID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_REQUEST,
  payload: { Id: RadScheduleRequestStatusID, Status: status, UserId: userId },
});
export const activateDeactivateRequeststatusSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_SUCCESS,
  payload: result,
});
export const activateDeactivateRequeststatusFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_FAILURE,
  payload: error,
});
//Requeststatus Actions - END

// Trauma Facility Level Actions - start
export const fetchTraumaFacilityLevelRequest = () => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_REQUEST,
});
export const fetchTraumaFacilityLevelSuccess = (data) => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_SUCCESS,
  payload: data,
});
export const fetchTraumaFacilityLevelFailure = (error) => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_FAILURE,
  payload: error,
});

export const deleteTraumaFacilityLevelRequest = (
  TramaFacilityLevelID,
  modifiedBy,
) => ({
  type: types.DELETE_TRAUMAFACILITYLEVEL_REQUEST,
  payload: { TramaFacilityLevelID, modifiedBy },
});
export const deleteTraumaFacilityLevelSuccess = (TramaFacilityLevelID) => ({
  type: types.DELETE_TRAUMAFACILITYLEVEL_SUCCESS,
  payload: TramaFacilityLevelID,
});
export const deleteTraumaFacilityLevelFailure = (error) => ({
  type: types.DELETE_TRAUMAFACILITYLEVEL_FAILURE,
  payload: error,
});

export const activateDeactivateTraumaFacilityLevelRequest = (
  TramaFacilityLevelID,
  status,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_REQUEST,
  payload: { TramaFacilityLevelID, status, modifiedBy },
});
export const activateDeactivateTraumaFacilityLevelSuccess = (response) => ({
  type: types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_SUCCESS,
  payload: response,
});
export const activateDeactivateTraumaFacilityLevelFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_FAILURE,
  payload: error,
});

export const saveTraumaFacilityLevelRequest = (traumaFacilityLevelData) => ({
  type: types.SAVE_TRAUMAFACILITYLEVEL_REQUEST,
  payload: traumaFacilityLevelData,
});
export const saveTraumaFacilityLevelSuccess = (traumaFacilityLevel) => ({
  type: types.SAVE_TRAUMAFACILITYLEVEL_SUCCESS,
  payload: traumaFacilityLevel,
});
export const saveTraumaFacilityLevelFailure = (error) => ({
  type: types.SAVE_TRAUMAFACILITYLEVEL_FAILURE,
  payload: error,
});

export const fetchTraumaFacilityLevelByIdRequest = (TramaFacilityLevelID) => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_REQUEST,
  payload: { TramaFacilityLevelID },
});
export const fetchTraumaFacilityLevelByIdSuccess = (traumaFacilityLevel) => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_SUCCESS,
  payload: traumaFacilityLevel,
});
export const fetchTraumaFacilityLevelByIdFailure = (error) => ({
  type: types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_FAILURE,
  payload: error,
});
// Trauma Facility Level Actions - End

//Qgenda Section Actions - start
export const fetchQgendaSectionsRequest = () => ({
  type: types.FETCH_QGENDA_SECTION_REQUEST,
});
export const fetchQgendaSectionsSuccess = (qgendaSection) => ({
  type: types.FETCH_QGENDA_SECTION_SUCCESS,
  payload: qgendaSection,
});
export const fetchQgendaSectionsFailure = (error) => ({
  type: types.FETCH_QGENDA_SECTION_FAILURE,
  payload: error,
});

export const deleteQgendaSectionRequest = (QGendaSectionID, ModifiedBy) => ({
  type: types.DELETE_QGENDA_SECTION_REQUEST,
  payload: { QGendaSectionID, ModifiedBy },
});
export const deleteQgendaSectionSuccess = (QGendaSectionID) => ({
  type: types.DELETE_QGENDA_SECTION_SUCCESS,
  payload: QGendaSectionID,
});
export const deleteQgendaSectionFailure = (error) => ({
  type: types.DELETE_QGENDA_SECTION_FAILURE,
  payload: error,
});

export const saveQgendaSectionRequest = (data) => ({
  type: types.SAVE_QGENDA_SECTION_REQUEST,
  payload: data,
});
export const saveQgendaSectionSuccess = (data) => ({
  type: types.SAVE_QGENDA_SECTION_SUCCESS,
  payload: data,
});
export const saveQgendaSectionFailure = (error) => ({
  type: types.SAVE_QGENDA_SECTION_FAILURE,
  payload: error,
});

export const fetchQgendaSectionByIdRequest = (Id) => ({
  type: types.FETCH_QGENDA_SECTION_BY_ID_REQUEST,
  payload: { QGendaSectionID: Id },
});
export const fetchQgendaSectionByIdSuccess = (QGendaSectionID) => ({
  type: types.FETCH_QGENDA_SECTION_BY_ID_SUCCESS,
  payload: QGendaSectionID,
});
export const fetchQgendaSectionByIdFailure = (error) => ({
  type: types.FETCH_QGENDA_SECTION_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateQgendaSectionRequest = (Id, Status, UserId) => ({
  type: types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_REQUEST,
  payload: { Id, Status, UserId },
});
export const activateDeactivateQgendaSectionSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_SUCCESS,
  payload: result,
});
export const activateDeactivateQgendaSectionFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_FAILURE,
  payload: error,
});
//Qgenda Section Actions - end

//Site Status Actions - Start
export const fetchSiteStatusRequest = () => ({
  type: types.FETCH_SITE_STATUS_REQUEST,
});
export const fetchSiteStatusSuccess = (siteStatus) => ({
  type: types.FETCH_SITE_STATUS_SUCCESS,
  payload: siteStatus,
});
export const fetchSiteStatusFailure = (error) => ({
  type: types.FETCH_SITE_STATUS_FAILURE,
  payload: error,
});

export const saveSiteStatusRequest = (siteStatusData) => ({
  type: types.SAVE_SITE_STATUS_REQUEST,
  payload: siteStatusData,
});
export const saveSiteStatusSuccess = (data) => ({
  type: types.SAVE_SITE_STATUS_SUCCESS,
  payload: data,
});
export const saveSiteStatusFailure = (error) => ({
  type: types.SAVE_SITE_STATUS_FAILURE,
  payload: error,
});

export const deleteSiteStatusRequest = (siteStatusId, modifiedBy) => ({
  type: types.DELETE_SITE_STATUS_REQUEST,
  payload: { siteStatusId, modifiedBy },
});
export const deleteSiteStatusSuccess = (message) => ({
  type: types.DELETE_SITE_STATUS_SUCCESS,
  payload: message,
});
export const deleteSiteStatusFailure = (error) => ({
  type: types.DELETE_SITE_STATUS_FAILURE,
  payload: error,
});

export const activateDeactivateSiteStatusRequest = (Id, Status, UserId) => ({
  type: types.ACTIVATE_DEACTIVATE_SITE_STATUS_REQUEST,
  payload: { Id, Status, UserId },
});
export const activateDeactivateSiteStatusSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_SITE_STATUS_SUCCESS,
  payload: message,
});
export const activateDeactivateSiteStatusFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SITE_STATUS_FAILURE,
  payload: error,
});

export const fetchSiteStatusByIdRequest = (SiteStatusID) => ({
  type: types.FETCH_SITE_STATUS_BY_ID_REQUEST,
  payload: { SiteStatusID },
});
export const fetchSiteStatusByIdSuccess = (SiteStatusID) => ({
  type: types.FETCH_SITE_STATUS_BY_ID_SUCCESS,
  payload: SiteStatusID,
});
export const fetchSiteStatusByIdFailure = (error) => ({
  type: types.FETCH_SITE_STATUS_BY_ID_FAILURE,
  payload: error,
});
//Site Status Actions - End

//Modality Actions - Start
export const fetchModalityRequest = () => ({
  type: types.FETCH_MODALITY_REQUEST,
});
export const fetchModalitySuccess = (modalities) => ({
  type: types.FETCH_MODALITY_SUCCESS,
  payload: modalities,
});
export const fetchModalityFailure = (error) => ({
  type: types.FETCH_MODALITY_FAILURE,
  payload: error,
});

export const saveModalityRequest = (modalityData) => ({
  type: types.SAVE_MODALITY_REQUEST,
  payload: modalityData,
});
export const saveModalitySuccess = (message) => ({
  type: types.SAVE_MODALITY_SUCCESS,
  payload: message,
});
export const saveModalityFailure = (error) => ({
  type: types.SAVE_MODALITY_FAILURE,
  payload: error,
});

export const deleteModalityRequest = (ModalityId, modifiedBy) => ({
  type: types.DELETE_MODALITY_REQUEST,
  payload: { ModalityId, modifiedBy },
});
export const deleteModalitySuccess = (message) => ({
  type: types.DELETE_MODALITY_SUCCESS,
  payload: message,
});
export const deleteModalityFailure = (error) => ({
  type: types.DELETE_MODALITY_FAILURE,
  payload: error,
});

export const activateDeactivateModalityRequest = (
  ModalityId,
  Status,
  UserId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_MODALITY_REQUEST,
  payload: { ModalityId, Status, UserId },
});
export const activateDeactivateModalitySuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_MODALITY_SUCCESS,
  payload: message,
});
export const activateDeactivateModalityFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_MODALITY_FAILURE,
  payload: error,
});

export const fetchModalityByIdRequest = (ModalityId) => ({
  type: types.FETCH_MODALITY_BY_ID_REQUEST,
  payload: { ModalityId },
});
export const fetchModalityByIdSuccess = (modalityData) => ({
  type: types.FETCH_MODALITY_BY_ID_SUCCESS,
  payload: modalityData,
});
export const fetchModalityByIdFailure = (error) => ({
  type: types.FETCH_MODALITY_BY_ID_FAILURE,
  payload: error,
});
//Modality Actions - End

//Priority Actions - Start
export const fetchPriorityRequest = () => ({
  type: types.FETCH_PRIORITY_REQUEST,
});
export const fetchPrioritySuccess = (priorities) => ({
  type: types.FETCH_PRIORITY_SUCCESS,
  payload: priorities,
});
export const fetchPriorityFailure = (error) => ({
  type: types.FETCH_PRIORITY_FAILURE,
  payload: error,
});

export const savePriorityRequest = (priorityData) => ({
  type: types.SAVE_PRIORITY_REQUEST,
  payload: priorityData,
});
export const savePrioritySuccess = (message) => ({
  type: types.SAVE_PRIORITY_SUCCESS,
  payload: message,
});
export const savePriorityFailure = (error) => ({
  type: types.SAVE_PRIORITY_FAILURE,
  payload: error,
});

export const deletePriorityRequest = (PriorityId, modifiedBy) => ({
  type: types.DELETE_PRIORITY_REQUEST,
  payload: { PriorityId, modifiedBy },
});
export const deletePrioritySuccess = (message) => ({
  type: types.DELETE_PRIORITY_SUCCESS,
  payload: message,
});
export const deletePriorityFailure = (error) => ({
  type: types.DELETE_PRIORITY_FAILURE,
  payload: error,
});

export const activateDeactivatePriorityRequest = (
  PriorityId,
  Status,
  UserId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_REQUEST,
  payload: { PriorityId, Status, UserId },
});
export const activateDeactivatePrioritySuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_SUCCESS,
  payload: message,
});
export const activateDeactivatePriorityFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_FAILURE,
  payload: error,
});

export const fetchPriorityByIdRequest = (PriorityId) => ({
  type: types.FETCH_PRIORITY_BY_ID_REQUEST,
  payload: { PriorityId },
});
export const fetchPriorityByIdSuccess = (priorityData) => ({
  type: types.FETCH_PRIORITY_BY_ID_SUCCESS,
  payload: priorityData,
});
export const fetchPriorityByIdFailure = (error) => ({
  type: types.FETCH_PRIORITY_BY_ID_FAILURE,
  payload: error,
});
//Priority Actions - End

//Priority Bucket Actions - Start
export const fetchPriorityBucketsRequest = () => ({
  type: types.FETCH_PRIORITY_BUCKETS_REQUEST,
});
export const fetchPriorityBucketsSuccess = (priorityBuckets) => ({
  type: types.FETCH_PRIORITY_BUCKETS_SUCCESS,
  payload: priorityBuckets,
});
export const fetchPriorityBucketsFailure = (error) => ({
  type: types.FETCH_PRIORITY_BUCKETS_FAILURE,
  payload: error,
});
//Priority Bucket Actions - End

// Staff Category
export const fetchStaffCategoriesRequest = () => ({
  type: types.FETCH_STAFF_CATEGORIES_REQUEST,
});

export const fetchStaffCategoriesSuccess = (staffCategories) => ({
  type: types.FETCH_STAFF_CATEGORIES_SUCCESS,
  payload: staffCategories,
});

export const fetchStaffCategoriesFailure = (error) => ({
  type: types.FETCH_STAFF_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchStaffCategoryByIdRequest = (StaffCategoryId) => ({
  type: types.FETCH_STAFF_CATEGORY_BY_ID_REQUEST,
  payload: { StaffCategoryId },
});

export const fetchStaffCategoryByIdSuccess = (StaffCategoryId) => ({
  type: types.FETCH_STAFF_CATEGORY_BY_ID_SUCCESS,
  payload: StaffCategoryId,
});

export const fetchStaffCategoryByIdFailure = (error) => ({
  type: types.FETCH_STAFF_CATEGORY_BY_ID_FAILURE,
  payload: error,
});

export const saveStaffCategoryRequest = (staffCategoryData) => ({
  type: types.SAVE_STAFF_CATEGORY_REQUEST,
  payload: staffCategoryData,
});

export const saveStaffCategorySuccess = (data) => ({
  type: types.SAVE_STAFF_CATEGORY_SUCCESS,
  payload: data,
});

export const saveStaffCategoryFailure = (error) => ({
  type: types.SAVE_STAFF_CATEGORY_FAILURE,
  payload: error,
});

export const deleteStaffCategoryRequest = (StaffCategoryId, modifiedBy) => ({
  type: types.DELETE_STAFF_CATEGORY_REQUEST,
  payload: { StaffCategoryId, modifiedBy },
});

export const deleteStaffCategorySuccess = (message) => ({
  type: types.DELETE_STAFF_CATEGORY_SUCCESS,
  payload: message,
});

export const deleteStaffCategoryFailure = (error) => ({
  type: types.DELETE_STAFF_CATEGORY_FAILURE,
  payload: error,
});

export const activateDeactivateStaffCategoryRequest = (Id, Status, UserId) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_REQUEST,
  payload: { Id, Status, UserId },
});

export const activateDeactivateStaffCategorySuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_SUCCESS,
  payload: message,
});

export const activateDeactivateStaffCategoryFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_FAILURE,
  payload: error,
});

// Staff Primary Location
export const fetchStaffPrimaryLocationsRequest = () => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATIONS_REQUEST,
});

export const fetchStaffPrimaryLocationsSuccess = (staffPrimaryLocations) => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATIONS_SUCCESS,
  payload: staffPrimaryLocations,
});

export const fetchStaffPrimaryLocationsFailure = (error) => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATIONS_FAILURE,
  payload: error,
});

export const fetchStaffPrimaryLocationByIdRequest = (
  StaffPrimaryLocationId,
) => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_REQUEST,
  payload: { StaffPrimaryLocationId },
});

export const fetchStaffPrimaryLocationByIdSuccess = (data) => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_SUCCESS,
  payload: data,
});

export const fetchStaffPrimaryLocationByIdFailure = (error) => ({
  type: types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_FAILURE,
  payload: error,
});

export const saveStaffPrimaryLocationRequest = (staffPrimaryLocationData) => ({
  type: types.SAVE_STAFF_PRIMARY_LOCATION_REQUEST,
  payload: staffPrimaryLocationData,
});

export const saveStaffPrimaryLocationSuccess = (data) => ({
  type: types.SAVE_STAFF_PRIMARY_LOCATION_SUCCESS,
  payload: data,
});

export const saveStaffPrimaryLocationFailure = (error) => ({
  type: types.SAVE_STAFF_PRIMARY_LOCATION_FAILURE,
  payload: error,
});

export const deleteStaffPrimaryLocationRequest = (
  staffPrimaryLocationId,
  modifiedBy,
) => ({
  type: types.DELETE_STAFF_PRIMARY_LOCATION_REQUEST,
  payload: { staffPrimaryLocationId, modifiedBy },
});

export const deleteStaffPrimaryLocationSuccess = (message) => ({
  type: types.DELETE_STAFF_PRIMARY_LOCATION_SUCCESS,
  payload: message,
});

export const deleteStaffPrimaryLocationFailure = (error) => ({
  type: types.DELETE_STAFF_PRIMARY_LOCATION_FAILURE,
  payload: error,
});

export const activateDeactivateStaffPrimaryLocationRequest = (
  Id,
  Status,
  UserId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_REQUEST,
  payload: { Id, Status, UserId },
});

export const activateDeactivateStaffPrimaryLocationSuccess = (message) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_SUCCESS,
  payload: message,
});

export const activateDeactivateStaffPrimaryLocationFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_FAILURE,
  payload: error,
});

// Specialty Cases Actions - START
export const fetchSpecialtyCasesRequest = () => ({
  type: types.FETCH_SPECIALTY_CASES_REQUEST,
});
export const fetchSpecialtyCasesSuccess = (data) => ({
  type: types.FETCH_SPECIALTY_CASES_SUCCESS,
  payload: data,
});
export const fetchSpecialtyCasesFailure = (error) => ({
  type: types.FETCH_SPECIALTY_CASES_FAILURE,
  payload: error,
});

export const deleteSpecialtyCasesRequest = (SpecialtyCaseID, modifiedBy) => ({
  type: types.DELETE_SPECIALTY_CASES_REQUEST,
  payload: { SpecialtyCaseID, modifiedBy },
});
export const deleteSpecialtyCasesSuccess = (SpecialtyCaseID) => ({
  type: types.DELETE_SPECIALTY_CASES_SUCCESS,
  payload: SpecialtyCaseID,
});
export const deleteSpecialtyCasesFailure = (error) => ({
  type: types.DELETE_SPECIALTY_CASES_FAILURE,
  payload: error,
});

export const saveSpecialtyCasesRequest = (specialtyCaseData) => ({
  type: types.SAVE_SPECIALTY_CASES_REQUEST,
  payload: specialtyCaseData,
});
export const saveSpecialtyCasesSuccess = (data) => ({
  type: types.SAVE_SPECIALTY_CASES_SUCCESS,
  payload: data,
});
export const saveSpecialtyCasesFailure = (error) => ({
  type: types.SAVE_SPECIALTY_CASES_FAILURE,
  payload: error,
});

export const fetchSpecialtyCasesByIdRequest = (SpecialtyCaseID) => ({
  type: types.FETCH_SPECIALTY_CASES_BY_ID_REQUEST,
  payload: { SpecialtyCaseID },
});
export const fetchSpecialtyCasesByIdSuccess = (data) => ({
  type: types.FETCH_SPECIALTY_CASES_BY_ID_SUCCESS,
  payload: data,
});
export const fetchSpecialtyCasesByIdFailure = (error) => ({
  type: types.FETCH_SPECIALTY_CASES_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateSpecialtyCasesRequest = (
  SpecialtyCaseID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_REQUEST,
  payload: { SpecialtyCaseID, status, userId },
});
export const activateDeactivateSpecialtyCasesSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_SUCCESS,
  payload: result,
});
export const activateDeactivateSpecialtyCasesFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_FAILURE,
  payload: error,
});
// Specialty Cases Actions - END

// Staffing Agency Actions - START
export const fetchStaffingAgencyRequest = () => ({
  type: types.FETCH_STAFFING_AGENCY_REQUEST,
});
export const fetchStaffingAgencySuccess = (data) => ({
  type: types.FETCH_STAFFING_AGENCY_SUCCESS,
  payload: data,
});
export const fetchStaffingAgencyFailure = (error) => ({
  type: types.FETCH_STAFFING_AGENCY_FAILURE,
  payload: error,
});

export const deleteStaffingAgencyRequest = (staffingAgencyId, modifiedBy) => ({
  type: types.DELETE_STAFFING_AGENCY_REQUEST,
  payload: { staffingAgencyId, modifiedBy },
});
export const deleteStaffingAgencySuccess = (staffingAgencyId) => ({
  type: types.DELETE_STAFFING_AGENCY_SUCCESS,
  payload: staffingAgencyId,
});
export const deleteStaffingAgencyFailure = (error) => ({
  type: types.DELETE_STAFFING_AGENCY_FAILURE,
  payload: error,
});

export const saveStaffingAgencyRequest = (staffingAgencyData) => ({
  type: types.SAVE_STAFFING_AGENCY_REQUEST,
  payload: staffingAgencyData,
});
export const saveStaffingAgencySuccess = (data) => ({
  type: types.SAVE_STAFFING_AGENCY_SUCCESS,
  payload: data,
});
export const saveStaffingAgencyFailure = (error) => ({
  type: types.SAVE_STAFFING_AGENCY_FAILURE,
  payload: error,
});

export const fetchStaffingAgencyByIdRequest = (staffingAgencyId) => ({
  type: types.FETCH_STAFFING_AGENCY_BY_ID_REQUEST,
  payload: { staffingAgencyId },
});
export const fetchStaffingAgencyByIdSuccess = (data) => ({
  type: types.FETCH_STAFFING_AGENCY_BY_ID_SUCCESS,
  payload: data,
});
export const fetchStaffingAgencyByIdFailure = (error) => ({
  type: types.FETCH_STAFFING_AGENCY_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateStaffingAgencyRequest = (
  staffingAgencyId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_REQUEST,
  payload: { staffingAgencyId, status, userId },
});
export const activateDeactivateStaffingAgencySuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_SUCCESS,
  payload: result,
});
export const activateDeactivateStaffingAgencyFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_FAILURE,
  payload: error,
});
// Staffing Agency Actions - END

// Document Type Actions - start
export const fetchProviderDocumentTypesRequest = () => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPES_REQUEST,
});
export const fetchProviderDocumentTypesSuccess = (data) => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPES_SUCCESS,
  payload: data,
});
export const fetchProviderDocumentTypesFailure = (data) => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPES_FAILURE,
  payload: data,
});

export const deleteProviderDocumentTypeRequest = (
  documentTypeId,
  modifiedBy,
) => ({
  type: types.DELETE_PROVIDER_DOCUMENTTYPE_REQUEST,
  payload: { documentTypeId, modifiedBy },
});
export const deleteProviderDocumentTypeSuccess = (documentTypeId) => ({
  type: types.DELETE_PROVIDER_DOCUMENTTYPE_SUCCESS,
  payload: documentTypeId,
});
export const deleteProviderDocumentTypeFailure = (error) => ({
  type: types.DELETE_PROVIDER_DOCUMENTTYPE_FAILURE,
  payload: error,
});

export const saveProviderDocumentTypeRequest = (docTypeData) => ({
  type: types.SAVE_PROVIDER_DOCUMENTTYPE_REQUEST,
  payload: docTypeData,
});
export const saveProviderDocumentTypeSuccess = (documentType) => ({
  type: types.SAVE_PROVIDER_DOCUMENTTYPE_SUCCESS,
  payload: documentType,
});
export const saveProviderDocumentTypeFailure = (error) => ({
  type: types.SAVE_PROVIDER_DOCUMENTTYPE_FAILURE,
  payload: error,
});

export const fetchProviderDocumentTypeByIdRequest = (docTypeId) => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_REQUEST,
  payload: docTypeId,
});
export const fetchProviderDocumentTypeByIdSuccess = (docType) => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_SUCCESS,
  payload: docType,
});
export const fetchProviderDocumentTypeByIdFailure = (error) => ({
  type: types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_FAILURE,
  payload: error,
});

export const updateProviderDocumentTypeRequest = (docTypeData) => ({
  type: types.UPDATE_PROVIDER_DOCUMENTTYPE_REQUEST,
  payload: docTypeData,
});
export const updateProviderDocumentTypeSuccess = (docType) => ({
  type: types.UPDATE_PROVIDER_DOCUMENTTYPE_SUCCESS,
  payload: docType,
});
export const updateProviderDocumentTypeFailure = (error) => ({
  type: types.UPDATE_PROVIDER_DOCUMENTTYPE_FAILURE,
  payload: error,
});

export const activateDeactivateProviderDocumentTypeRequest = (payload) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_REQUEST,
  payload: payload,
});
export const activateDeactivateProviderDocumentTypeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_SUCCESS,
  payload: result,
});
export const activateDeactivateProviderDocumentTypeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_FAILURE,
  payload: error,
});
// Document Type Actions - end

// Provider Note Type Actions - start
export const fetchProviderNoteTypesRequest = () => ({
  type: types.FETCH_PROVIDER_NOTETYPES_REQUEST,
});
export const fetchProviderNoteTypesSuccess = (data) => ({
  type: types.FETCH_PROVIDER_NOTETYPES_SUCCESS,
  payload: data,
});
export const fetchProviderNoteTypesFailure = (data) => ({
  type: types.FETCH_PROVIDER_NOTETYPES_FAILURE,
  payload: data,
});

export const deleteProviderNoteTypeRequest = (noteTypeId, modifiedBy) => ({
  type: types.DELETE_PROVIDER_NOTETYPE_REQUEST,
  payload: { RadNoteTypeID: noteTypeId, ModifiedBy: modifiedBy },
});
export const deleteProviderNoteTypeSuccess = (noteTypeId) => ({
  type: types.DELETE_PROVIDER_NOTETYPE_SUCCESS,
  payload: noteTypeId,
});
export const deleteProviderNoteTypeFailure = (error) => ({
  type: types.DELETE_PROVIDER_NOTETYPE_FAILURE,
  payload: error,
});

export const saveProviderNoteTypeRequest = (noteTypeData) => ({
  type: types.SAVE_PROVIDER_NOTETYPE_REQUEST,
  payload: noteTypeData,
});
export const saveProviderNoteTypeSuccess = (noteType) => ({
  type: types.SAVE_PROVIDER_NOTETYPE_SUCCESS,
  payload: noteType,
});
export const saveProviderNoteTypeFailure = (error) => ({
  type: types.SAVE_PROVIDER_NOTETYPE_FAILURE,
  payload: error,
});

export const fetchProviderNoteTypeByIdRequest = (noteTypeId) => ({
  type: types.FETCH_PROVIDER_NOTETYPE_BY_ID_REQUEST,
  payload: noteTypeId,
});
export const fetchProviderNoteTypeByIdSuccess = (noteType) => ({
  type: types.FETCH_PROVIDER_NOTETYPE_BY_ID_SUCCESS,
  payload: noteType,
});
export const fetchProviderNoteTypeByIdFailure = (error) => ({
  type: types.FETCH_PROVIDER_NOTETYPE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateProviderNoteTypeRequest = (payload) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_REQUEST,
  payload: payload,
});
export const activateDeactivateProviderNoteTypeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_SUCCESS,
  payload: result,
});
export const activateDeactivateProviderNoteTypeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_FAILURE,
  payload: error,
});
// Provider Note Type Actions - end

// Update Dropdown management Reducer
export const updateDropdownMgmtReducer = (data) => ({
  type: types.UPDATE_DROPDOWN_MANAGEMENT_REDUCER,
  payload: data,
});
